module.exports = __webpack_public_path__ + "img/react.4009eef3.svg";